"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeTrigger = void 0;
var mobx_1 = require("mobx");
var index_1 = require("../index");
/**
 * Mobx Trigger
 *
 * This can be used to force a mobx autorun to cause the autorun to re-run
 *
 */
var IkeTrigger = /** @class */ (function () {
    function IkeTrigger(name) {
        var _this = this;
        this.timeout = null;
        /** Report that the trigger has changed causing the autorun to fire */
        this.run = function () {
            if (_this.isTriggering) {
                _this.timeout = null;
            }
            _this.atom.reportChanged();
        };
        this.atom = (0, mobx_1.createAtom)("trigger: ".concat(name, " "));
    }
    Object.defineProperty(IkeTrigger.prototype, "isTriggering", {
        /** Wether the trigger is scheduled to run */
        get: function () {
            return this.timeout != null;
        },
        enumerable: false,
        configurable: true
    });
    /** Observe the trigger, generally used inside of a autorun */
    IkeTrigger.prototype.observe = function () {
        this.atom.reportObserved();
    };
    /** Schedule the trigger to run on the next animation frame*/
    IkeTrigger.prototype.trigger = function () {
        if (this.isTriggering) {
            return;
        }
        this.timeout = index_1.Services.Window.window.requestAnimationFrame(this.run);
    };
    return IkeTrigger;
}());
exports.IkeTrigger = IkeTrigger;
//# sourceMappingURL=trigger.js.map